import { render, staticRenderFns } from "./CostosM.vue?vue&type=template&id=657f348e&"
import script from "./CostosM.vue?vue&type=script&lang=ts&"
export * from "./CostosM.vue?vue&type=script&lang=ts&"
import style0 from "./CostosM.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports